export default function probability(value) {
  return Math.random() < value / 100;
}
